export const allTeams = JSON.parse(`[
    {
        "id": "GN6T73QJMJT6PGT",
        "name": "Alemania",
        "nameAbbrev": "GER",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2206.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/1500.png"
    },
    {
        "id": "GN10Q0066RYCD63",
        "name": "Arabia Saudita",
        "nameAbbrev": "KSA",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4374.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3072.png"
    },
    {
        "id": "GN0Z3X6855XN43P",
        "name": "Argentina",
        "nameAbbrev": "ARG",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2768.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3029.png"
    },
    {
        "id": "GN4K3H1KMG1HR2E",
        "name": "Australia",
        "nameAbbrev": "AUS",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2229.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3059.png"
    },
    {
        "id": "GNDPVBPY1CBN882",
        "name": "Brasil",
        "nameAbbrev": "BRA",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2235.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/1035.png"
    },
    {
        "id": "GNE0VFY10J2Q7JP",
        "name": "Bélgica",
        "nameAbbrev": "BEL",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2205.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3004.png"
    },
    {
        "id": "GNF40MXHR3YXM2S",
        "name": "Camerún",
        "nameAbbrev": "CMR",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4351.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3075.png"
    },
    {
        "id": "GN9PN5ZEH07GF9F",
        "name": "Canadá",
        "nameAbbrev": "CAN",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2231.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3049.png"
    },
    {
        "id": "GNBGY5M9KMN8E53",
        "name": "Catar",
        "nameAbbrev": "QAT",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/9640.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/102370.png"
    },
    {
        "id": "GN0MFWSX7TR5TC7",
        "name": "Corea del Sur",
        "nameAbbrev": "KOR",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4391.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3068.png"
    },
    {
        "id": "GNAMV9APZY4CSZ1",
        "name": "Costa Rica",
        "nameAbbrev": "CRC",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2771.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3090.png"
    },
    {
        "id": "GNAMDSYB2VWJCZY",
        "name": "Croacia",
        "nameAbbrev": "CRO",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4354.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/523.png"
    },
    {
        "id": "GN35YRBCHES0H99",
        "name": "Dinamarca",
        "nameAbbrev": "DEN",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2220.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/406.png"
    },
    {
        "id": "GN5NM2T728912WK",
        "name": "Ecuador",
        "nameAbbrev": "ECU",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4333.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3065.png"
    },
    {
        "id": "GN8N1G480P5H6HV",
        "name": "España",
        "nameAbbrev": "ESP",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2203.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/413.png"
    },
    {
        "id": "GND4E8T69HJCYCD",
        "name": "Estados Unidos",
        "nameAbbrev": "USA",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2209.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3019.png"
    },
    {
        "id": "GNDKWAMRBAP7DVY",
        "name": "Francia",
        "nameAbbrev": "FRA",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2202.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/461.png"
    },
    {
        "id": "GN31DA8MADTY6MC",
        "name": "Gales",
        "nameAbbrev": "WAL",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4386.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3017.png"
    },
    {
        "id": "GN0MF7YTFAY301H",
        "name": "Ghana",
        "nameAbbrev": "GHA",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4339.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3025.png"
    },
    {
        "id": "GNEWS27CQRA7F8Q",
        "name": "Inglaterra",
        "nameAbbrev": "ENG",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2208.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/436.png"
    },
    {
        "id": "GN5GBJ9XAE377F6",
        "name": "Irán",
        "nameAbbrev": "IRN",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4348.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3033.png"
    },
    {
        "id": "GN6AGN17D1B453T",
        "name": "Japón",
        "nameAbbrev": "JPN",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2241.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3062.png"
    },
    {
        "id": "GNA0R58H42SG1NV",
        "name": "Marruecos",
        "nameAbbrev": "MAR",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2779.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3014.png"
    },
    {
        "id": "GN7VASH15HKYQA7",
        "name": "México",
        "nameAbbrev": "MEX",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2228.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3010.png"
    },
    {
        "id": "GN1NKHKNE81WZNW",
        "name": "Países Bajos",
        "nameAbbrev": "NED",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2201.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/411.png"
    },
    {
        "id": "GN4Y21300EHG549",
        "name": "Polonia",
        "nameAbbrev": "POL",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2214.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3006.png"
    },
    {
        "id": "GN794EMZMP05YB5",
        "name": "Portugal",
        "nameAbbrev": "POR",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2223.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/450.png"
    },
    {
        "id": "GN6Z2A16KJ6HV46",
        "name": "Senegal",
        "nameAbbrev": "SEN",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4375.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3026.png"
    },
    {
        "id": "GN891PZVRCA79YW",
        "name": "Serbia",
        "nameAbbrev": "SRB",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/6944.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3000.png"
    },
    {
        "id": "GNCKSCV9KY3GCDW",
        "name": "Suiza",
        "nameAbbrev": "SUI",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2213.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/408.png"
    },
    {
        "id": "GN0D2ZYT69QGC49",
        "name": "Túnez",
        "nameAbbrev": "TUN",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2246.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3023.png"
    },
    {
        "id": "GN8YCH3CR2Y7CC0",
        "name": "Uruguay",
        "nameAbbrev": "URU",
        "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2787.png",
        "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3024.png"
    }
]`);


// WEBPACK FOOTER //
// ./src/mundial/requests/mockData/allTeams.ts